import { Dialog, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useSnackbar } from "notistack";
import React from "react";
import CustomButtonAdmin from "../../../components/form/CustomButtonAdmin";
import theme from "../../../theme";
import moment from "moment/min/moment-with-locales";
import { updateElement } from "../../../database/API";
import { diaBlock } from "../../../utils";

function DialogChangeBlock({ data, open, setOpen, loading, setLoading, setUpdate, dataBlock }) {
    const { enqueueSnackbar } = useSnackbar();

    const handleClose = () => {
        setOpen(false);
    };

    const deleteRestriccio = async (block_free) => {
        setLoading(true);
        await updateElement("data_block", { block_free }, data);
        enqueueSnackbar("Disponibilitat canviada", {
            variant: "success",
        });
        setOpen(false);
        setUpdate((prev) => prev + 1);
    };

    return (
        <Dialog onClose={handleClose} open={open} maxWidth="lg">
            <DialogTitle sx={{ background: theme.color.primary, color: "white" }}>Canviar bloqueig data</DialogTitle>
            <DialogContent>
                <Typography variant="h5" mt={3} textAlign={"center"}>
                    {moment(data).format("LL")}
                </Typography>
                <Stack direction={"row"} spacing={1}>
                    <CustomButtonAdmin title="Tancar" fullWidth onClick={() => setOpen(false)} />
                    {diaBlock(dataBlock, moment(data).format("YYYY-MM-DD"), moment(data).weekday() === 5 || moment(data).weekday() === 6) ? (
                        <CustomButtonAdmin onClick={() => deleteRestriccio(0)} title="Posar com a disponible" fullWidth danger loading={loading} />
                    ) : (
                        <CustomButtonAdmin onClick={() => deleteRestriccio(1)} title="Bloquejar dia" fullWidth danger loading={loading} />
                    )}
                </Stack>
            </DialogContent>
        </Dialog>
    );
}

export default DialogChangeBlock;
